import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, {useRef, useState} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as addToLookActions from '../../actions/addToLook'
import * as cross from '../../store/cross'
import * as looks from '../../store/looks'
import * as user from '../../store/user'

import useOnDocumentMousedown from '../../hooks/useOnDocumentMousedown'

import AddToLookDropdown from './AddToLookDropdown'
import LineItemTooltipLabel from '../LineItemTooltipLabel'
import Svg from '../Svg'

import chevronDownThick from '../../../../svg/chevron-down-thick.svg'

const AddToLookButton = ({
  addProductToLook,
  addRecommendedProductsToLook,
  buttonText,
  hasNonHtoLooks,
  isAuthenticated,
  isRentSoldOutForEvent,
  modifier,
  selectedTransactionType,
  isCTL,
  showBuyPathExperiment,
}) => {
  const node = useRef()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const origin = isCTL ? 'completeTheLook' : 'pdp'
  const buyPathOrigin = 'Buy Experiment pdp'

  function handleDocumentClick(event) {
    if (isDropdownOpen && !node.current.contains(event.target)) {
      setIsDropdownOpen(false)
    }
  }
  useOnDocumentMousedown(handleDocumentClick)

  function handleOnButtonClick() {
    if (hasNonHtoLooks) {
      setIsDropdownOpen(true)
    } else if (isCTL) {
      addRecommendedProductsToLook(null, showBuyPathExperiment ? buyPathOrigin : origin)
    } else {
      addProductToLook(null, showBuyPathExperiment ? buyPathOrigin : origin)
    }
  }

  function handleOnMouseEnter() {
    if (hasNonHtoLooks && !isRentSoldOutForEvent && !!selectedTransactionType) {
      setIsDropdownOpen(true)
    }
  }

  const pdpAtlButton = (
    <button
      type="button"
      className="pdp-atl-button"
      aria-expanded={hasNonHtoLooks ? isDropdownOpen : null}
      onClick={handleOnButtonClick}
      disabled={isCTL ? false : !selectedTransactionType}
    >
      <span className="pdp-atl-button-text">{buttonText}</span>
      {!isAuthenticated ? null : (
        <Svg className="pdp-atl-button-arrow" src={chevronDownThick} Tag="span" />
      )}
    </button>
  )

  return (
    <div
      className={classNames('pdp-atl', {
        [`pdp-atl--${modifier}`]: modifier,
        'is--authenticated': isAuthenticated,
        'is--dropdown-open': isDropdownOpen,
        'is--sold-out': isRentSoldOutForEvent,
      })}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={() => setIsDropdownOpen(false)}
      ref={node}
    >
      {!selectedTransactionType && !isCTL ? (
        <LineItemTooltipLabel
          label={pdpAtlButton}
          tooltipText="Please select Rent or Buy to continue"
        />
      ) : (
        pdpAtlButton
      )}
      <AddToLookDropdown
        isCTL={isCTL}
        isOpen={isDropdownOpen}
        origin={showBuyPathExperiment ? buyPathOrigin : origin}
        modifier={modifier}
      />
    </div>
  )
}

AddToLookButton.defaultProps = {
  buttonText: 'Add to Look',
}

AddToLookButton.propTypes = {
  addProductToLook: PropTypes.func.isRequired,
  addRecommendedProductsToLook: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  hasNonHtoLooks: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isCTL: PropTypes.bool,
  isRentSoldOutForEvent: PropTypes.bool.isRequired,
  modifier: PropTypes.string,
  selectedTransactionType: PropTypes.string,
  showBuyPathExperiment: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  hasNonHtoLooks: looks.hasNonHtoLooks,
  isAuthenticated: user.isAuthenticated,
  isRentSoldOutForEvent: cross.isRentSoldOutForEvent,
  selectedTransactionType: cross.selectedTransactionType,
})

const mapDispatchToProps = {
  addProductToLook: addToLookActions.addProductToLook,
  addRecommendedProductsToLook: addToLookActions.addRecommendedProductsToLook,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToLookButton)
